// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.kryptogo",
    name: "KryptoGO Wallet",
    homepage: "https://kryptogo.com/wallet",
    image_id: "4eb31988-f494-403c-6127-cfcef036ac00",
    app: {
        browser: "https://kryptogo.com/wallet",
        ios: "https://apps.apple.com/il/app/kryptogo/id1593830910",
        android: "https://play.google.com/store/apps/details?id=com.kryptogo.walletapp",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/bgaihnkooadagpjddlcaleaopmkjadfl",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "kryptogo://",
        universal: "https://kryptogo.page.link",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map